export default __webpack_public_path__ + "ed70e12d5f0baf71fa30737eb36d8997.png";